import type { DashboardViewOpts } from '@/services/DashboardService';

export const DASHBOARD_KEYS = {
  all: ['dashboard'] as const,
  view: (role: string, opts?: DashboardViewOpts) => [...DASHBOARD_KEYS.all, 'view', role, opts ?? {}] as const,
  unreadCount: (programid: string) => [...DASHBOARD_KEYS.all, 'unreadCount', programid] as const,
} as const;
